import React, { useState, Fragment, useEffect, memo, useCallback } from 'react';
import { connect } from 'react-redux';
import Banner from '../Banners/Banner';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';
import Quiz from './Quiz';
import { dataLayerParams } from '~/src/helpers/quiz';

const QuizGame = ({ pointEntry, marginBottom }) => {
    const [isShowQuiz, setIsShowQuiz] = useState(false);
    const [isShowBanner, setIsShowBanner] = useState(true);

    const clickOnBannerHandler = useCallback(() => {
        setIsShowQuiz(true);
        const timeout = setTimeout(() => {
            setIsShowBanner(false);
            clearTimeout(timeout);
        }, 1000);
    }, []);

    const onCloseQuiz = useCallback(() => setIsShowQuiz(false), []);

    useEffect(() => {
        dataLayerPush(dataLayerParams({ category: 'quiz game', action: 'view quiz' }));
    }, []);

    return (
        <Fragment>
            {
                isShowBanner &&
                <GridContainer>
                    <Banner
                        title={pointEntry.title}
                        description={pointEntry.title_ad}
                        image={process.env.CONTENT_API_ENDPOINT + pointEntry.image}
                        titleButton={pointEntry.button_text}
                        onClickHandler={clickOnBannerHandler}
                        backgroundColor='#F5AFD1'
                        titleTag='p'
                        marginBottom={marginBottom}
                    />
                </GridContainer>
            }
            {
                isShowQuiz &&
                <Quiz
                    clickOnClose={onCloseQuiz}
                />
            }
        </Fragment>
    );
};

const mapStateToProps = state => ({
    pointEntry: state.quiz.quiz.pointEntry
});

export default connect(mapStateToProps)(memo(QuizGame));
